import { pickGenericEnemyCard } from './generic';
import type { EnemyAiDecision, EnemyAiDecisionContext } from './types';

export function pickMercenaryCard(context: EnemyAiDecisionContext): EnemyAiDecision {
  return pickGenericEnemyCard(context);
}
